import Joi from '@hapi/joi'

export const BestPluckerPerfromanceSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    pluckingType: Joi.number().invalid("All").required().label("Plucking Type").messages({
        "any.invalid": `Select Plucking Type`,
        "any.required": `Plucking Type required`
    }),
    searchDate: Joi.string().invalid("").label("Search Date")
}

